import { useSelector } from "react-redux";
import { showInFullScreen } from "../specials/FullScreenView";
const ResturantGalleryDetails = () => {
  const details = useSelector((s) => s?.placeDetails ?? {});
  const imagesArray = [...details?.photos, ...details?.menuImages];
  console.log({ details });
  return (
    <div>
      <h4
        className="f-5 text-white my-3  text-center"
        style={{ letterSpacing: "9px" }}
      >
        Restaurant
      </h4>
      <div className="resturant-detail-div">
        <div
          onClick={(e) => showInFullScreen(e?.target, imagesArray)}
          className="bg-primary-half-brown p-3"
          style={{ borderRadius: "6px" }}
        >
          <div className="grid-md-container-2 gap-3">
            {/* Left Section */}
            <div>
              {imagesArray?.[0] && (
                <img
                  src={imagesArray[0]}
                  height={160}
                  className="object-fit-cover clickable-photo full-width"
                  onClick={(e) => showInFullScreen(e.target, imagesArray)}
                />
              )}
              <div className="grid-md-container-2 gap-3 mt-3">
                {imagesArray?.[1] && (
                  <img
                    src={imagesArray[1]}
                    height={160}
                    className="object-fit-cover clickable-photo full-width"
                    onClick={(e) => showInFullScreen(e.target, imagesArray)}
                  />
                )}
                {imagesArray?.[2] && (
                  <img
                    src={imagesArray[2]}
                    height={160}
                    className="object-fit-cover clickable-photo full-width"
                    onClick={(e) => showInFullScreen(e.target, imagesArray)}
                  />
                )}
              </div>
            </div>
            {/* Right Section */}
            <div className="grid-md-container-2 gap-3">
              {imagesArray?.[3] && (
                <img
                  src={imagesArray[3]}
                  height={336}
                  className="full-width clickable-photo object-fit-cover"
                  onClick={(e) => showInFullScreen(e.target, imagesArray)}
                />
              )}
              <div>
                {imagesArray?.[4] && (
                  <img
                    src={imagesArray[4]}
                    height={160}
                    className="full-width clickable-photo object-fit-cover"
                    onClick={(e) => showInFullScreen(e.target, imagesArray)}
                  />
                )}
                {imagesArray?.[5] && (
                  <img
                    src={imagesArray[5]}
                    height={160}
                    className="full-width clickable-photo object-fit-cover mt-3"
                    onClick={(e) => showInFullScreen(e.target, imagesArray)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="position-relative mt-3">
          <video
            controls
            src={details?.details?.videos?.[0] ?? details?.videos[0]}
            height={300}
            style={{
              borderRadius: "22px",
            }}
            muted
            className="full-width object-fit-cover"
          />
        </div>
      </div>
    </div>
  );
};
export default ResturantGalleryDetails;
